import { useId, useState } from "react";
import { Checkbox, Link, type CheckboxProps } from "@mui/material";
import { useTranslations } from "use-intl";
import MoreDetailsDrawer from "../flight-purchase/MoreDetailsDrawer/MoreDetailsDrawer";

type Props = CheckboxProps;

export const TermsAndConditions = (props: Props) => {
  const t = useTranslations();
  const checkboxId = useId();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="flex gap-2">
        <div className="shrink-0">
          <Checkbox id={checkboxId} sx={{ p: 0 }} {...props} />
        </div>

        <div className="flex flex-col items-start gap-1 pt-1">
          <label
            className="text-sm font-semibold text-text-primary"
            htmlFor={checkboxId}
          >
            {t("hotels.acceptGeneralTerms")}
          </label>
          <div className="text-sm text-text-tertiary">
            {t("hotels.acceptGeneralTermsWarning")}
          </div>
          <Link
            onClick={() => setMoreDetailsOpen(true)}
            component="button"
            type="button"
          >
            {t("moreDetails")}
          </Link>
        </div>
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
};
